import React from "react";
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from "react-places-autocomplete";
import logger from "../services/Logger";

class LocationSearchInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = { address: "" };
    this.inputRef = React.createRef();
  }

  handleChange = (address) => {
    this.setState({ address });
  };

  handleSelect = (address) => {
    geocodeByAddress(address)
      .then((results) => {
        logger.info("Selected address", results);
        this.handleChange(results[0].formatted_address);
        this.props.onSelect(results[0].formatted_address);
        getLatLng(results[0]).then((latLng) => {
          logger.info("Success", latLng);
        });
      })
      .catch((error) => logger.error("Error", error));
  };

  handleKeyDown = (e, suggestions) => {
    // If Tab is pressed and there are suggestions with an active one
    if (e.key === "Tab" && suggestions.length > 0) {
      const activeSuggestion = suggestions.find((suggestion) => suggestion.active);
      if (activeSuggestion) {
        e.preventDefault(); // Prevent default tab behavior
        this.handleSelect(activeSuggestion.description);
        // Use setTimeout to ensure the selection is complete before tabbing
        setTimeout(() => {
          // Find the next focusable element
          const focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
          const elements = document.querySelectorAll(focusableElements);
          const currentIndex = Array.from(elements).indexOf(e.target);
          const nextElement = elements[currentIndex + 1];
          if (nextElement) {
            nextElement.focus();
            // Try to select all text in the input
            if (nextElement.tagName.toLowerCase() === "input") {
              try {
                nextElement.select();
              } catch (error) {
                // If select() fails, try setSelectionRange
                try {
                  nextElement.setSelectionRange(0, nextElement.value.length);
                } catch (err) {
                  // If both methods fail, just focus the element
                }
              }
            }
          }
        }, 0);
      }
    }
  };

  render() {
    return (
      <PlacesAutocomplete value={this.state.address} onChange={this.handleChange} onSelect={this.handleSelect}>
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
          <div>
            <input
              {...getInputProps({
                placeholder: "Search Places ...",
                className: "location-search-input",
                style: {
                  width: "400px",
                },
                onKeyDown: (e) => this.handleKeyDown(e, suggestions),
                ref: this.inputRef,
              })}
            />
            <div className="autocomplete-dropdown-container">
              {loading && <div>Loading...</div>}
              {suggestions.map((suggestion) => {
                const className = suggestion.active ? "suggestion-item--active" : "suggestion-item";
                // inline style for demonstration purpose
                const style = suggestion.active ? { backgroundColor: "#fafafa", cursor: "pointer" } : { backgroundColor: "#ffffff", cursor: "pointer" };
                return (
                  <div
                    {...getSuggestionItemProps(suggestion, {
                      className,
                      style,
                    })}
                  >
                    <span>{suggestion.description}</span>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </PlacesAutocomplete>
    );
  }
}

export default LocationSearchInput;
